import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    catImg: {
        width:'100%',
        height:200,
        marginVertical: 10,
        borderRadius: 10
    },
    categoryWrapper: {
        marginHorizontal:10
    },
    catDetails: {
        position:'absolute',
        bottom:10,
        left:0,
        padding:15,
        width:'100%',
        borderBottomLeftRadius:10,
        borderBottomRightRadius:10
    },
    catName: {
        color:'#fff',
        fontFamily:'Raleway',
        fontWeight:'bold',
        fontSize:14
    },
    catCount: {
        color:'#fff',
        fontFamily:'Raleway',
    }
})